/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./like.defs.js";
export { main as default } from "./like.defs.js";
